export default {
  参观商: 'Buyer',
  主办商: 'Event Organizer',
  参展商: 'Exhibitor',
  设计师: 'Designer',
  '设计师（企业）': 'Designer (Company)',
  '设计师（个人）': 'Designer (Individual)',
  工程商: 'Contractor',
  展厅工程商: 'Contractor',
  主账号: 'Company Account',
  子账号: 'Employee Account',
  岗位名称: 'Position',
  手机: 'Cellphone Number',
  手机号: 'Cellphone Number',
  手机号码: 'Cellphone Number',
  固话: 'Fixed Phone Number',
  电话: 'Phone Number',
  邮箱: 'E-mail',
  地址: 'Address',
  姓名: 'Name',
  公司: 'Company Name',
  公司地址: 'Company Address',
  普通会员: 'Regular User',
  普通用户: 'User',
  VIP会员: 'VIP User',
  开通VIP会员: 'Become a VIP Now!',
}
